import React from "react";

const Keyword = ({ keyword }) => {
  return <li>{keyword}</li>;
};

export default Keyword;
